var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EE741F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4286,
    height: 15.4286,
    transform: "translate(4.14453 19.7148) rotate(-90)",
    fill: "#EE741F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71483 17.5176C9.39051 17.1933 9.36102 16.6857 9.62638 16.3281L9.71483 16.2257L13.9406 11.9994L9.71483 7.77323C9.39051 7.4489 9.36102 6.94139 9.62638 6.58375L9.71483 6.48129C10.0392 6.15697 10.5467 6.12749 10.9043 6.39284L11.0068 6.48129L15.8789 11.3535C16.2033 11.6778 16.2328 12.1853 15.9674 12.5429L15.8789 12.6454L11.0068 17.5176C10.65 17.8743 10.0716 17.8743 9.71483 17.5176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRightChevron);
export default __webpack_public_path__ + "static/media/orange-right-chevron.56d6cc21f58aa88bc2ed2fe042d5369c.svg";
export { ForwardRef as ReactComponent };